import { defineStore } from 'pinia'
import { RouteLocationNormalized } from 'vue-router'
import { useTitle } from '@vueuse/core'

// 不需要缓存的组件名称
const excludeView = ['Redirect']

export default defineStore('tab', {
  state: () => ({
    // 选项卡
    tabs: [
      { fullPath: '/store', title: '首页', name: 'Home', affix: true }
    ] as TabPane[],
    // 当前激活的视图路径
    activeKey: '/store',
    // 不缓存的组件名称
    exclude: $util.clone(excludeView)
  }),
  actions: {
    // 路由成功后，将视图写入选项卡
    push(route: RouteLocationNormalized) {
      const panes = this.tabs.filter(tab => tab.fullPath === route.fullPath)
      // 如果选项卡中已经存在相同路径的项目，则直接跳转到此项目
      if (panes.length > 0) {
        this.activeKey = panes[0].fullPath
        useTitle(panes[0].title + ' - 简单猫')  // 设置浏览器标题
        return
      }
      let title = route.meta.title as string
      // 如果路由参数中存在title属性，则将title加入到视图名称后面，在浏览器标题栏、选项卡显示
      if (route.params.title) title += '-' + route.params.title
      this.tabs.push({ fullPath: route.fullPath, name: route.name as string, title, affix: false })
      this.activeKey = route.fullPath
      useTitle(title + ' - 简单猫')
    },
    // 关闭选项卡
    remove(pane: TabPane) {
      // 找到要关闭的选项卡在数组中的未知
      const index = this.tabs.indexOf(pane)
      // 不缓存的视图名称中增加此组件的名称
      this.exclude.push(pane.name)
      // 从选项卡数组中删除
      this.tabs.splice(index, 1)
      // 如果关闭的选项卡并不是当前打开的项目，则无需切换视图
      if (pane.fullPath !== this.activeKey) {
        this.setPane()
        return
      }
      // 如果关闭的选项卡是当前打开的视图，则选择关闭视图的前一个视图，并打开
      const prevPane = this.tabs[index - 1]
      this.setPane(prevPane)
    },
    // 刷新选项卡
    refresh(pane: TabPane) {
      // 不缓存的视图名称中增加此组件的名称
      this.exclude.push(pane.name)
      // 通过路由跳转，回到当前视图，会重新加载视图
      $router.push('/redirect?key=' + pane.fullPath)
      // 重新设置视图
      this.setPane()
    },
    // 移除其他视图（固定和所选的除外）
    removeOther(pane: TabPane) {
      this.removeAll(pane)
    },
    // 移除全部视图
    removeAll(pane?: TabPane) {
      // 找到非所选或非固定的选项卡
      const tabs = this.tabs.filter(a => !a.affix && a !== pane)
      // 将需要关闭的视图加入到无需缓存的视图名称中，并将其从选项卡数组中移除
      tabs.forEach(tab => {
        this.exclude.push(tab.name)
        const index = this.tabs.indexOf(tab)
        this.tabs.splice(index, 1)
      })
      // 如果是关闭其他所有，则切换到所选的视图
      if (pane) {
        this.setPane(pane)
        return
      }
      // 如果是关闭所有，则切换到首页
      const firstPane = this.tabs[0]
      this.setPane(firstPane)
    },
    // 设置视图
    setPane(pane?: TabPane) {
      // 如果有需要切换的视图，则直接跳转（如果当前路由与需要跳转的路由一致，也不会有任何变化）
      if (pane) {
        $router.push(pane.fullPath)
        this.activeKey = pane.fullPath
      }
      // 设置无需缓存的视图名称为默认值，使用宏任务
      setTimeout(() => {
        this.exclude = $util.clone(excludeView)
      }, 0)
    }

  }
})
